const locale = {
  "Rain and Lightning map": "Bản đồ mưa sét toàn quốc",
  "Today's weather": "Thời tiết hôm nay trên toàn quốc",
};

export default locale;
